import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { BodySizeButton } from 'page/ProfileScreen/BodySizes/BodySizeButton'
import { opt } from 'store/opt'
import { BodyIndex } from 'type/Identity'

export const BodySizes = observer(() => {
  const { irnby } = opt
  const bodies: BodyIndex[] = irnby ? [1, 2, 3] : [1, 2, 3, 4, 5]

  return <Panel>
    {bodies.map(body => <BodySizeButton key={body} body={body} />)}
  </Panel>
})
